import React, { Component } from "react"
import { connect } from "react-redux"
import { Card } from "react-bootstrap"
import { Link } from "react-router-dom/cjs/react-router-dom"
import ClientForm from "../../components/forms/ClientForm"
import MaterialIcon from "../../components/elements/MaterialIcon"
import { FormattedMessage } from "react-intl"
import { getCountriesAction } from "../../actions/countriesActions"
import { getIndustriesAction } from "../../actions/industriesActions"

class ClientCreatePage extends Component {

	componentDidMount() {
		this.props.getCountriesAction({ pageSize: 150, sorted: null, filters: [], page: 1 })
		this.props.getIndustriesAction({ pageSize: 150, sorted: null, filters: [], page: 1 })
	}

	render() {
		return (
			<div className="clients-create-page private-page">
				<div className="top-actions-row">
					<Link to="/clients" className="btn-primary btn-roundet btn-dropshadow btn btn-sm"><MaterialIcon icon="arrow_back" /> <FormattedMessage id="buttons.back_to_client" /> </Link>
				</div>
				<Card className="clients-card fadeInLoadUp">
					<Card.Body>
						<ClientForm />
					</Card.Body>
				</Card>
			</div>
		)
	}
}

ClientCreatePage.propTypes = {
}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, {getCountriesAction, getIndustriesAction})(ClientCreatePage)
